require("!!/var/lib/jenkins/workspace/TEST3/webapp/node_modules/script-loader/addScript.js")(require("!!/var/lib/jenkins/workspace/TEST3/webapp/node_modules/raw-loader/index.js!/var/lib/jenkins/workspace/TEST3/webapp/src/main/webapp/js/lib/kendo/kendo.draganddrop.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/main/webapp/js/lib/kendo/kendo.draganddrop.min.js
// module id = 175
// module chunks = 37